import { useEffect, useRef } from 'react';
import maplibregl from 'maplibre-gl';
import ZoomInfoControl from '@App/components/ZoomInfoControl/ZoomInfoControl';

import 'maplibre-gl/dist/maplibre-gl.css';
import './map.styl';

function Map({ mapStyle }) {
  const mapRef = useRef(null);
  
  useEffect(() => {
    const map = new maplibregl.Map({
      container: mapRef.current,
      style: `/styles/${mapStyle}/style.json`,
      attributionControl: false,
    });

    map.addControl(new maplibregl.AttributionControl({
      customAttribution: '© OpenStreetMap contributors',
    }));

    map.addControl(new ZoomInfoControl());

    return () => map.remove();
  }, [mapStyle]);

  return (
    <div ref={mapRef} className="map" />
  );
}

export default Map;